/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Role } from './Role';
import { RoleFromJSON, RoleFromJSONTyped, RoleToJSON } from './Role';

/**
 *
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
  /**
   *
   * @type {number}
   * @memberof UserProfile
   */
  readonly id: number;
  /**
   *
   * @type {Role}
   * @memberof UserProfile
   */
  readonly role: Role;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  profileImage?: string | null;
}

/**
 * Check if a given object implements the UserProfile interface.
 */
export function instanceOfUserProfile(value: object): value is UserProfile {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('role' in value) || value['role'] === undefined) return false;
  return true;
}

export function UserProfileFromJSON(json: any): UserProfile {
  return UserProfileFromJSONTyped(json, false);
}

export function UserProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfile {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    role: RoleFromJSON(json['role']),
    profileImage: json['profile_image'] == null ? undefined : json['profile_image'],
  };
}

export function UserProfileToJSON(value?: Omit<UserProfile, 'id' | 'role'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    profile_image: value['profileImage'],
  };
}
